// src/components/HDImpactCards.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './HDImpactCards.css';

const HDImpactOutlineCard = ({ logoSrc, title, value, bgColor, infoText }) => {
  return (
    <div
      className="hdimpact-outline-card"
      style={{ backgroundColor: bgColor }}
    >
      <div className="hdimpact-card-header">
        <img src={logoSrc} alt="Logo" className="hdimpact-logo" />
        <h3>
          {title}
          <span className="info-wrapper">
            <span className="info-icon">i</span>
            <div className="tooltip">{infoText}</div>
          </span>
        </h3>
      </div>

      <div className="hdimpact-card-content">
        <p>
          <strong>{value}</strong>
        </p>
      </div>
    </div>
  );
};

const formatNumber = (num) => {
  return new Intl.NumberFormat().format(num);
};

const HDImpactCards = () => {
  const [hdImpactValues, setHDImpactValues] = useState({
    applications_submitted: '',
    citizen_impacted: '',
    msmes_impacted: '',
    hds_trained: '',
    benefits_unlocked: ''
  });

  const fetchData = async () => {
    try {
      // 🔥 SAME API as CitizenImpactCards
      const response = await axios.post(
        "https://api-sales-insights.haqdarshak.com/landing-page-cards"
      );

      const data = response.data;

      setHDImpactValues({
        applications_submitted: formatNumber(data.Total_App_Submitted || 0),

        citizen_impacted: formatNumber(data.DFL_Unique_citizens || 0),

        msmes_impacted: formatNumber(data.Total_Citz_reached || 0),

        hds_trained: formatNumber(data.Num_of_hd_Trained || 0),

        benefits_unlocked:
          formatNumber((data.Total_BV_Received / 10000000 || 0).toFixed(2)) +
          " crore"
      });

    } catch (error) {
      console.error("Error fetching HD Impact API data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="hdimpact-card-container">

        <HDImpactOutlineCard
          logoSrc="/Citizen_Impacted.jpg"
          title="DFL Trained Individuals"
          value={hdImpactValues.citizen_impacted}
          bgColor="var(--citizen-impacted-color)"
          infoText='Individuals trained on digital and financial literacy since April’23'
        />

        <HDImpactOutlineCard
          logoSrc="/Application_Submitted.jpg"
          title="Applications Submitted"
          value={hdImpactValues.applications_submitted}
          bgColor="var(--applications-submitted-color)"
          infoText='Total number of schemes where the application has reached the "Document Submitted" status.'
        />

        <HDImpactOutlineCard
          logoSrc="/MSMEs_Impacted.jpg"
          title="Citizens Reached"
          value={hdImpactValues.msmes_impacted}
          bgColor="var(--msmes-impacted-color)"
          infoText='Total number of unique citizens that have been reached or screened.'
        />

        <HDImpactOutlineCard
          logoSrc="/HDs_Trained.jpg"
          title="HDs Trained"
          value={hdImpactValues.hds_trained}
          bgColor="var(--hds-trained-color)"
          infoText="Total number of HD's who have been trained or onboarded."
        />

        <HDImpactOutlineCard
          logoSrc="/Benefits_Unblocked.jpg"
          title="Benefits Unlocked"
          value={hdImpactValues.benefits_unlocked}
          bgColor="var(--benefits-unblocked-color)"
          infoText="The total value of benefits unlocked."
        />

      </div>
    </div>
  );
};

export default HDImpactCards;